import { mapGetters } from 'vuex';
import LoginIcon from '@/frontend/components/icons/LoginIcon';
export default {
  name: "LoginButtonComponent",
  components: {
    LoginIcon
  },
  computed: mapGetters(['can', 'user'])
};